import { TFunction } from 'i18next';

import { SWITCH_CHANNEL_DESTINATIONS, SwitchChannelDestination } from '@/shared/types/action';
import { IntegrationType } from '@/shared/types/integration';

import { getChannelKey } from './channelName';

const isDestination = (channel?: string): channel is SwitchChannelDestination =>
  SWITCH_CHANNEL_DESTINATIONS.includes(channel as SwitchChannelDestination);

/** The translated channel name, e.g. "Webchat". Unknown channels keep their raw value. */
export const switchChannelName = (t: TFunction, channel?: string) =>
  isDestination(channel) ? t(getChannelKey(channel as IntegrationType)) : (channel ?? '');
